<template>
  <div>
    <div v-if="!payload" class="flex flex-center" style="padding: 20px 0;">
      <van-loading size="80px" vertical>数据加载中...</van-loading>
    </div>
    <template v-else>
      <div class="com-page-title">
        <div class="inner">{{ payload.name }}</div>
      </div>
      <div class="com-card">
        <div class="com-card-title">
          <span>大功德主</span>
          <span class="right-txt">¥{{ payload.price }}</span>
        </div>
        <div class="com-card-content">
          <div class="text-wrap" v-html="payload.lordofmeritList.map(lst => lst.brief).join('').replace(/\n/gi, '<br>')" />
          <br>
          <!-- <div class="van-hairline--bottom" />
          <br> -->
          <div class="com-form-wrap">
            <van-form label-width="100px">
              <template v-for="(lst, index) in payload.lordofmeritList" :key="lst.id">
                <van-field colon>
                  <template #label>
                    <DictionaryText typeCode="gongfengfangshi" :dictValue="lst.way"/>数量
                  </template>
                  <template #input>
                    <van-stepper v-model="form.numbers[lst.id]" :min="payload.lordofmeritList.length > 1 ? 0 : 1" :max="payload.lordofmeritNumber - Object.keys(form.numbers).map(key => form.numbers[key]).reduce((t, v) => t + v) + form.numbers[lst.id]" />
                  </template>
                </van-field>
                <!-- <div class="text-wrap">
                  <p>{{ lst.brief }}</p>
                </div> -->
                <template v-if="index == payload.lordofmeritList.length - 1">
                  <van-field
                    class="field-yellow"
                    label="尺寸规格"
                    readonly
                    colon
                  >
                    <template #input>
                      <DictionaryText typeCode="chicunguige" :dictValue="lst.specification"/>
                    </template>
                  </van-field>
                  <van-field
                    class="field-yellow"
                    label="供奉时间"
                    readonly
                    colon
                  >
                    <template #input>
                      {{ payload.date }}(农历)
                    </template>
                  </van-field>
                  <van-field
                    class="field-yellow"
                    label="供奉位置"
                    readonly
                    colon
                  >
                    <template #input>
                      <DictionaryText typeCode="gongfengweizhi" :dictValue="payload.location"/>
                    </template>
                  </van-field>
                </template>
              </template>
            </van-form>
            <div class="com-form-submit">
              <DefaultBtn @click="navToNext">登记信息</DefaultBtn>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import DictionaryText from '@/components/common/DictionaryText'
  export default {
    data () {
      return {
        payload: null,
        form: {
          numbers: {}
        }
      }
    },
    mounted () {
      this.getData()
    },
    methods: {
      // 获取法会信息
      getData () {
        this.$faWuApi.faHui.getItemData({
          id: this.$route.query.id
        }).then(res => {
          if (res.success) {
            this.payload = res.data
            res.data.lordofmeritList.forEach(item => {
              this.form.numbers[item.id] = 1
            })
          } else {
            this.$toast(res.errMessage)
          }
        })
      },
      // 页面跳转
      navToNext () {
        // 进入下一页验证
        let nextHandle = true
        let params = JSON.parse(JSON.stringify(this.form.numbers))
        for (const key in params) {
        //   if (!params[key] || params[key] == 0) {
        //     delete params[key]
        //   }
          if (params[key] && params[key] > 0) {
            nextHandle = false
          }
        }
        if (!nextHandle) {
          this.$router.push({
            path: 'record',
            query: {
              pId: this.payload.id,
              numbers: JSON.stringify(params)
            }
          })
        } else {
          this.$toast('请选择牌位数量')
        }
      }
    },
    components: {
      DictionaryText
    }
  }
</script>